import { Autocomplete, Checkbox, TextField } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { buscarComboPorCodigo } from "../../services/auth.service";
import { useEffect, useState } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const AutoCompleteMultiply = ({
  labelProp,
  placeHolderProp,
  onChange,
  codigoCombo,
  required = false,
  selectionId = null,
  valueReturn,
  opcaoSelecionarTodos = false,
  width,
  name,
}) => {
  const [msg, setMsg] = useState("");
  const [value, setValue] = useState(null);
  const [genericList, setGenericList] = useState([]);
  const [genericLabel, setGenericLabel] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleChange = async (event, selectedOptions) => {
    if (selectedOptions.length > 0) {
      if (parseInt(selectedOptions[selectedOptions.length - 1].id) === 0) {
        await selectAllOptions();
      } else {
        onChange(selectedOptions);
      }
    } else {
      onChange(selectedOptions);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await buscarComboPorCodigo(codigoCombo);
        let listaItens = [];
        if (opcaoSelecionarTodos) {
          listaItens.push("0/|/Selecionar Todos");
        }
        const itens = (response?.detalhes?.itensCombo ?? []).filter((item) => {
          return (
            typeof item === "string" &&
            item.includes("/|/") &&
            !item.startsWith("undefined")
          );
        });

        if (opcaoSelecionarTodos) {
          itens.unshift("0/|/Selecionar Todos");
        }
        const itensGenericList = itens.map((item) => {
          const [id, label] = item.split("/|/");
          return {
            id: id?.trim() ?? "",
            label: label?.trim() ?? "",
          };
        });

        setGenericList(itensGenericList);
        setGenericLabel(
          required
            ? `${response.detalhes.descricao} *`
            : response.detalhes.descricao
        );

        if (selectionId) {
          setValue(
            itensGenericList.find(
              (option) => option.id === selectionId.toString()
            )
          );
        }
      } catch (err) {
        if (err.response) {
          setMsg(err.response.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    };

    fetchData();
  }, [codigoCombo]);

  const selectAllOptions = async () => {
    const allOptions = genericList.filter((option) => option.id !== "0");
    await onChange(allOptions);
  };

  return (
    <div>
      <Autocomplete
        value={valueReturn}
        onChange={handleChange}
        multiple
        id="checkboxes-tags-demo"
        options={genericList}
        disableCloseOnSelect
        fullWidth
        getOptionLabel={(option) => option?.label ?? ""}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option?.label ?? ""}
          </li>
        )}
        style={{ width: width }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={labelProp}
            placeholder={placeHolderProp}
            name={name}
          />
        )}
      />
    </div>
  );
};
